module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_BG-482b7dcda0018d92c8f2a3e6c5c06a39.svg";